import {
  TableCell,
  TableRow
} from '@mui/material';
import _ from 'lodash';

export type CompanyFinancialMetricsHeaderRowProps = {
  headerValues: string[];
};

export const FC = (props: CompanyFinancialMetricsHeaderRowProps) => {
  const lastValue = _.last(props.headerValues);
  const allButLast = _.slice(props.headerValues, 0, props.headerValues.length - 1);

  return (
    <TableRow>
      {allButLast.map((node, i) => (
        <TableCell
          key={`header-${i}`}
          variant='finacialHeader'
        >
          {node?.toString()}
        </TableCell>
      ))}

      {/* The name */}
      <TableCell
        variant='finacialHeader'
      />

      <TableCell
        variant='finacialHeader'
        align='right'
      >
        {lastValue}
      </TableCell>
    </TableRow>
  );
};
